import React from 'react';
import PropTypes from 'prop-types';
import Immutable from 'immutable';
import loadScript from 'load-script';
import some from 'lodash/some';
import { FormattedMessage } from 'react-intl';
import { catalogBibShape, bibShape, libraryShape } from '@bibliocommons/bc-prop-types';
import { SecondaryLink } from '@bibliocommons/base-links';
import ScreenReaderMessage from '@bibliocommons/base-screen-reader-message';

import { FullScreenOverlayContainer } from 'app/components/shared/FullScreenOverlay';
import ExcerptOverlay from './ExcerptOverlay';

import './BibExcerpt.scss';

export default class BibExcerpt extends React.PureComponent {
  state = { open: false, googlePreviewAvailable: false };

  componentDidMount() {
    if (!this.props.currentLibrary.get('googleBook')) return;
    // Check if google preview is available to conditionally render "Read an excerpt" link
    const isbns = this.props.bib.getIn(['briefInfo', 'isbns'], Immutable.List()).join(',');

    const googlePreviewCheckUrl = `https://books.google.com/books?jscmd=viewapi&bibkeys=${isbns}`;
    loadScript(googlePreviewCheckUrl, () => {
      // _GBSBookInfo is defined in the global scope by the google script,
      // and contains data about the book (if it's available)
      if (some(window._GBSBookInfo, val => val.preview !== 'noview')) this.setState({ googlePreviewAvailable: true });
    });
  }

  handleOpen = () => this.setState({ open: true });

  handleClose = () => this.setState({ open: false });

  renderExcerptLink = () => {
    const { catalogBib } = this.props;
    const catalogBibBrief = catalogBib.get('brief');
    const title = catalogBibBrief.get('title');

    return (
      <SecondaryLink href="#excerpt-overlay" dataKey="excerpt-link" handleClick={this.handleOpen} preventDefault>
        <span aria-hidden>
          <FormattedMessage id="read_excerpt" />
        </span>
        <ScreenReaderMessage>
          <FormattedMessage id="sr_read_excerpt" values={{ title }} />
        </ScreenReaderMessage>
      </SecondaryLink>
    );
  };

  render() {
    if (!this.props.excerpt && !this.state.googlePreviewAvailable) return null;

    return (
      <div className="cp-bib-excerpt">
        {this.renderExcerptLink()}
        <FullScreenOverlayContainer
          open={this.state.open}
          handleClose={this.handleClose}
          overlayKey="bib-excerpt-full-screen-overlay"
          dataKey="bib-excerpt-full-screen-overlay"
        >
          {this.state.open && (
            <ExcerptOverlay {...this.props} googlePreviewAvailable={this.state.googlePreviewAvailable} />
          )}
        </FullScreenOverlayContainer>
      </div>
    );
  }
}

BibExcerpt.propTypes = {
  excerpt: PropTypes.string,
  catalogBib: catalogBibShape.isRequired,
  bib: bibShape.isRequired,
  currentLibrary: libraryShape.isRequired
};
